module.exports = __webpack_public_path__ + "static/img/12.c86081d0.gif";